import React, { memo } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { View, StyleSheet } from 'react-native';

import { Text, TextInput } from '../core-ui';
import { spacing } from '../constants/theme';

type Props = {
  'data-testid'?: string;
  from: string;
  until: string;
  setFrom: (value: string) => void;
  setUntil: (value: string) => void;
};

const SearchByViewers = memo((props: Props) => {
  let { from, until, setFrom, setUntil } = props;
  return (
    <View style={[styles.flex, styles.row, styles.root]}>
      <View style={[styles.flex, styles.row]}>
        <SearchIcon color="inherit" fontSize="default" />
        <Text style={[styles.flex, styles.label]}>
          {t(['Cari Dilihat', 'Search by Viewers'])}
        </Text>
      </View>
      <View style={[styles.flex, styles.row]}>
        <TextInput
          data-testid={`${props['data-testid']}`}
          containerStyle={styles.input}
          value={from}
          onChangeText={setFrom}
          type="number"
        />
        <Text style={styles.to}>to</Text>
        <TextInput
          data-testid={`${props['data-testid']}`}
          containerStyle={styles.input}
          value={until}
          onChangeText={setUntil}
          type="number"
        />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  root: { height: 36, paddingHorizontal: spacing.xsmall },
  flex: { flex: 1 },
  row: { flexDirection: 'row', alignItems: 'center' },
  label: { paddingLeft: spacing.small },
  to: { paddingHorizontal: spacing.xsmall },
  input: { width: 120 },
});

export default SearchByViewers;
